import React from 'react'
import Header from './header'
import Footer from './Footer'
import Newsletter from './HomeNewsletter'

function Blogdetail() {
  return (
    <div>
        
        <Header/>
                <section className='blog-detail-page'>
                      <div className="container my-5">
    <div className="row">
      <div className="col-md-9 blog-detail-left">
      <img className="service-image" width="400" height="262" alt="" src="/assets/images/service-one.png"/>
        <h1 className="mb-2">How to Design a Great Website</h1>
        <p className="text-muted">By John Doe | July 9, 2025</p>

        <div className="blog-content mt-4">
          <p>
            Creating a modern, user-friendly website involves a mix of design skills, UX strategy, and development know-how. In this article, we'll walk through the essential steps to design a professional website.
          </p>

          <h2>1. Understand Your Audience</h2>
          <p>
            Before you even open your design tool, take time to understand who you’re designing for. What are their needs, goals, and problems? A great website always starts with empathy for the user.
          </p>

          <h2>2. Plan Your Content Structure</h2>
          <p>
            Use tools like wireframes or site maps to organize your content. This helps define your pages, hierarchy, and key calls-to-action.
          </p>

        <img className="service-image" width="400" height="262" alt="" src="/assets/images/service-one.png"/>

          <h2>3. Focus on UI and UX</h2>
          <p>
            Choose a clean, readable font, proper color contrast, and a consistent layout. Use spacing and visual hierarchy to guide your user’s eye through the page.
          </p>

          <h2>4. Make It Responsive</h2>
          <p>
            Mobile-first design is essential today. Ensure your site adapts beautifully to phones, tablets, and desktops alike using responsive frameworks like Bootstrap.
          </p>

          <p>
            In conclusion, design is not just about beauty — it’s about function, emotion, and clarity. When done right, it can turn casual visitors into loyal users.
          </p>
        </div>
      </div>
      <div className="col-md-3 mt-5 mt-md-0">
        <div className="sidebar">
          <div className="mb-4">
            <h5>Search</h5>
            <form>
              <div className="input-group">
                <input type="text" className="form-control" placeholder="Search..."/>
                <button className="btn btn-primary" type="submit">Go</button>
              </div>
            </form>
          </div>
          <div className="mb-4">
            <h5>Categories</h5>
            <div className="list-group">
              <a href="#" className="list-group-item list-group-item-action">Technology</a>
              <a href="#" className="list-group-item list-group-item-action">Lifestyle</a>
              <a href="#" className="list-group-item list-group-item-action">Design</a>
              <a href="#" className="list-group-item list-group-item-action">Travel</a>
            </div>
          </div>
          <div>
            <h5>Recent Posts</h5>
            <ul className="list-unstyled">
              <li><a href="#" className="text-decoration-none">The Future of Web Design</a></li>
              <li><a href="#" className="text-decoration-none">Why Responsive Design Matters</a></li>
              <li><a href="#" className="text-decoration-none">Tips for Better UX</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
                </section>
        <Footer/>
    </div>
  )
}

export default Blogdetail
